import React, { useState } from "react";
import heroVideo1 from "../videos/hero_booking1.mp4";



export default function Booking() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    time: "",
    instructions: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Booking submitted! We'll contact you soon.");
    console.log(formData);
    setFormData({
      name: "",
      email: "",
      phone: "",
      service: "",
      date: "",
      time: "",
      instructions: "",
    });
  };

  return (
    
    <div className="container py-5">
      <h2 className="text-center mb-4">Book a Service</h2>
       {/* Video Left */}
    <div 
    className="d-flex flex-wrap justify-content-center align-items-start gap-4"
    style={{ maxWidth: "500px", margin: "0 auto" }} // centers the whole block
  >
      <video
  src={heroVideo1}
  autoPlay
  loop
  muted
  playsInline
  style={{
    width: "100%",
    borderRadius: "12px",
    objectFit: "cover",
   paddingRight:"100px",
    padding:"100px",
  }}
/>

    </div>
      <form onSubmit={handleSubmit} className="mx-auto" style={{ maxWidth: "600px" }}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Phone</label>
          <input
            type="tel"
            name="phone"
            className="form-control"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Service</label>
          <select
            name="service"
            className="form-select"
            value={formData.service}
            onChange={handleChange}
            required
          >
            <option value="">-- Select --</option>
            <option value="Carpenter">Carpenter</option>
            <option value="Tile Works">Tile Works</option>
            <option value="Cleaning">Cleaning</option>
            <option value="Plumbing">Plumbing</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Preferred Date</label>
          <input
            type="date"
            name="date"
            className="form-control"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Preferred Time</label>
          <input
            type="time"
            name="time"
            className="form-control"
            value={formData.time}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Special Instructions</label>
          <textarea
            name="instructions"
            className="form-control"
            value={formData.instructions}
            onChange={handleChange}
            rows="3"
          />
        </div>

        <button type="submit" className="btn btn-purple w-100">
          Submit Booking
        </button>
      </form>
      {/* Cleaning Animations Section */}
<div className="cleaning-wrapper mt-3">

  {/* 1) Wipe Shine Animation */}
  <div className="clean-wipe mb-3">
    Cleaning in Progress...
  </div>

  {/* 2) Broom Sweeping Animation */}
  <div className="broom-area mb-3">
    🧹
  </div>

  {/* 3) Floating Cleaning Bubbles */}
  <div className="bubble-clean mb-3">
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
  </div>

  {/* 4) Mop Cleaning Loader */}
  <div className="clean-loader mb-3">
    <span className="mop">🧽</span>
    <p>Cleaning...</p>
  </div>

</div>

    </div>
    
  );
}
